import script from "./TrendRankingCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendRankingCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__